import { cloneDeep } from "lodash";
import { AioExternalReplacements, AioReplacement, AioReplacementValues } from "./interface";
import { updateExternals } from "./updateExternals";

/**
 * Update a single replacement with external replacements.
 *
 * @param rep - The replacement to update
 * @param exts - External replacements
 * @returns AioReplacement<T>
 */
export const updateExternal = <T>(
  rep: AioReplacement<T>,
  exts?: AioExternalReplacements<T>[],
): AioReplacement<T> => {
  const ix =
    rep.externalName !== undefined && exts !== undefined
      ? exts.findIndex((e) => e.givenName === rep.externalName)
      : -1;
  let found: AioReplacementValues<T>[] | undefined =
    ix > -1 && exts !== undefined && exts.length > ix ? cloneDeep(exts[ix].newTexts) : undefined;
  if (!found) {
    found = rep.newTexts.some((nt) => nt.subLists !== undefined)
      ? rep.newTexts.map((nts) => {
          return {
            ...nts,
            subLists: updateExternals(nts.subLists, exts),
          };
        })
      : rep.newTexts;
  }
  const newR: AioReplacement<T> = {
    ...rep,
    newTexts: found,
  };
  return newR;
};
